module.exports = __webpack_public_path__ + "img/logo.774d50f6.png";